export const ACCOUNT_DROPDOWN_VERTICAL_BANNER_INFO =
  'account-dropdown-vertical-banner-info'
